import axios from "axios";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { handleBuyAllInvoice } from "../../../redux/actoin";
import { API } from "../../../scripts/api";
import axiosInstance from "../../../scripts/axiosInspector";

const PAGE_SIZE = 10;

const InvoiceData = (page, render) => {
  const [loading, setLoading] = useState(true);
  const [errors, setError] = useState(false);
  const [invoices, setInovoices] = useState([]);
  const [lastRender, setLastRender] = useState(1);
  const [hasMore, setHasMore] = useState(1);
  const [CurrentPage, setCurrentPage] = useState(null);
  const dispatch = useDispatch();
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const CurrentCompany = useSelector((state) => state.CurrentCompany);
  const { company } = CurrentCompany;
  const AllInvoiceBuy = useSelector((state) => state.AllInvoiceBuy);
  useEffect(() => {
    setInovoices([]);
  }, [render]);

  useEffect(() => {
    if (!userInfo || !company) return;
    if (render === lastRender && AllInvoiceBuy.invoices?.page === page) {
      setCurrentPage(AllInvoiceBuy.invoices?.page);
      setHasMore(AllInvoiceBuy.invoices?.hasMore);
      setInovoices(AllInvoiceBuy.invoices?.invoices);
      setLoading(false);
    } else {
      setLastRender(render);
      setLoading(true);
      setError(false);
      let cancel;
      const params = new URLSearchParams();
      page && params.append("page", page);
      company && params.append("guidStateRecNo", company?.guidRecNo);
      params.append("pageSize", PAGE_SIZE);
      axiosInstance
        .get(API.int.listBuy + `?${params}`, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${userInfo?.token}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
            "Accept-Language": "fa-IR",
            chHostName: process.env.REACT_APP_CHHOSTNAME,
          },
          cancelToken: new axios.CancelToken((c) => (cancel = c)),
        })
        .then((res) => {
          if (res.data.isSuccess) {
            if (CurrentPage === page) {
              setInovoices(res.data.data.rows);
              dispatch(
                handleBuyAllInvoice({
                  page,
                  hasMore: res.data.data.totalCount / PAGE_SIZE > page,
                  invoices: res.data.data.rows,
                })
              );
            } else {
              setInovoices((prev) => {
                return [...new Set([...prev, ...res.data.data.rows])];
              });
              dispatch(
                handleBuyAllInvoice({
                  page,
                  hasMore: res.data.data.totalCount / PAGE_SIZE > page,
                  invoices: [...new Set([...invoices, ...res.data.data.rows])],
                })
              );
            }

            setCurrentPage(page);
            setHasMore(res.data.data.totalCount / PAGE_SIZE > page);
          }
          setLoading(false);
        })
        .catch((err) => {
          if (axios.isCancel(err)) return;
          /*        if (err.response.status === 401 || err.response.status === 403) {
            dispatch(handleLogOut());
          } */
          setError(true);
        });
      return () => cancel();
    }
  }, [page, company, userInfo, render]);
  return { hasMore, loading, errors, invoices, CurrentPage };
};

export default InvoiceData;
